'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.constant('BACK_PRIORITY', {
    //view: 100,
    //sideMenu: 150,
    //modal: 200,
    //actionSheet: 300,
    //popup: 400,
    //loading: 500,
    photoSwipe: 800,
    accountOperate: 700,
    jLoading: 1000
  });
};

; /**
   * 返回键 处理优先级
   * 不覆盖ionic预定义好的模块
   */


//////////////////
// WEBPACK FOOTER
// ./src/app/BACK_PRIORITY.js
// module id = 30
// module chunks = 0